import * as React from 'react';
import { Search } from 'lucide-react';
import { Input } from './Input';
import { Stack } from './Layout';

export interface SearchFieldProps {
  value: string;
  /** Called with the new text on every keystroke. */
  onChange: (value: string) => void;
  placeholder?: string;
  /** What a screen reader calls the field. Falls back to the placeholder. */
  label?: string;
  /** Take the slack in the row. On by default; a filter row is the usual home. */
  grow?: boolean;
}

/**
 * A search box: an Input with the magnifier in front of it, grown to fill
 * the row it sits in.
 *
 *   <SearchField value={query} onChange={setQuery} placeholder="Search invoices" />
 *
 * The invoices, drivers and call-log lists each had their own copy of these
 * six lines, differing only in the placeholder.
 */
export function SearchField({
  value,
  onChange,
  placeholder = 'Search…',
  label,
  grow = true,
}: SearchFieldProps) {
  return (
    <Stack gap={0} grow={grow}>
      <Input
        leadingIcon={<Search />}
        placeholder={placeholder}
        aria-label={label ?? placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Stack>
  );
}
